
export default {
  inject: ['wording'],
  props: {
    addedToBundle: {
      type: Boolean,
      required: true,
      default: false,
    },
    selectedSize: {
      type: String,
      required: false,
      default: null,
    },
    wording: {
      type: Object,
      required: true,
    },
  },
  methods: {
    addToBundle() {
      this.$emit('addToBundle')
    },
    removeFromBundle() {
      this.$emit('removeFromBundle')
    },
  },
}
